import { DialogContainer, DialogTitle, DialogBody, DialogActions } from '../../../common';

const ErrorDialog = ({ open, onClose }) => {
  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>Error</DialogTitle>
      <DialogBody>Es necesario seleccionar un archivo.</DialogBody>
      <DialogActions handleClose={onClose} handleSave={null} />
    </DialogContainer>
  );
};

export default ErrorDialog;
